export const noSuggestionsToShowMessage = "dnDuPd";
export default {noSuggestionsToShowMessage};